import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import "./styles/index.css";

// Register service worker with auto-update handling
const updateSW = registerSW({
  onNeedRefresh() {
    if (window.confirm("New version available! Click OK to update.")) {
      updateSW();
    }
  },
});

// Add beforeinstallprompt event listener for custom install button
let deferredPrompt: any;
window.addEventListener("beforeinstallprompt", (e) => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later
  deferredPrompt = e;
});

// Handle app installation success
window.addEventListener("appinstalled", (evt) => {
  console.log("App installed successfully");
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
